import React from 'react';
import './ChooseLens.scss';
import { Icon } from '../../../components/ui/index';

const ChooseLens = () => {
  return (
    <>
      <div id="frame-and-lenses-step" className="about-step active">
        <div className="step-section section1">
          <div className="wrapper">
            <div className="column left">
              <Icon imgPath="/images/about/about-glass-step1.jpg"></Icon>
            </div>
            <div className="column right">
              <h2>
                VisionHub, <br /> it's 240 models
              </h2>
              <p>
                With a catalog of frames gathering many different brands and fashion, combining SV
                and PAL lenses also as sunglasses, readers and lots of different visual corrections,
                VisionHub is proud to say that :
              </p>
              <p>
                <span className="bold">You will find what you need !</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="choose-lens step-section section2">
        <div className="column left">
          <div className="step-icon">
            <Icon imgPath="/images/about/light-icon.png"></Icon>
            <Icon imgPath="/images/about/bulb-icon.png"></Icon>
          </div>
          <div className="step-info">
            <h2>Guaranteed protection</h2>
            <p>
              You are only a few clicks from getting your new glasses. Whatever utilisation you will
              make of it you can be sure that our products will always protect you.
            </p>
          </div>
        </div>
        <div className="column right">
          <div className="step-icon">
            <Icon imgPath="/images/about/virtual-icon.png"></Icon>
          </div>
          <div className="step-info">
            <h2>Virtual try on</h2>
            <p>
              Thanks to our innovative tool you will be able to see how you will look with your new
              glasses. No fashion mistake.
            </p>
          </div>
        </div>
      </div>
      <div className="choose-lens step-section section3">
        <div className="wrapper">
          <div className="column left">
            <Icon imgPath="/images/about/about-chat-step1.png"></Icon>
          </div>
          <div className="column right">
            <h2>
              How to choose
              <br />
              your lenses
            </h2>
            <p>
              Your lense’s selection is essential for a better vision. Our online assistance will
              help you at every step of your purchase answering your needs and assuring yourself the
              best fitting product. Simple and clear explanations will be here anytime to answer
              your questions regarding your final order.
            </p>
          </div>
        </div>
      </div>
      <div className="choose-lens step-section section4">
        <div className="wrapper">
          <h2>Our lenses</h2>
          <div className="column left">
            <ul>
              <li>
                <h3 className="polycarbonate">Polycarbonate</h3>
                <p>
                  This unbreakable lens is 30% lighter than a basic lens and offers an entire safety
                  in the everyday life.
                </p>
              </li>
              <li>
                <h3 className="hi-index167">Hi-Index</h3>
                <p>
                  This lens is up to 40% thinner than a basic lens making it the thinnest lens on
                  the market. It is the perfect partner for all frame designs.
                </p>
              </li>
            </ul>
          </div>
          <div className="column right">
            <ul>
              <li>
                <h3 className="anti-reflective">Anti-reflective</h3>
                <p>
                  The clearer lens, an incomparable transparency for the best vision. This lens also
                  protects against scratches, glares and dusts. It provides the best contrasts and
                  comfort, by day as by night.
                </p>
              </li>
              <li>
                <h3 className="transition-gray">Transitions© gray</h3>
                <p>
                  This adaptive lens, thanks to its photochromic technology, will automatically
                  adapt to any light conditions, reducing glare with a 100% UV protection for your
                  eyes.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChooseLens;
